import React, { FC } from 'react'

import { Loader, ErrorHandler } from 'components'
import { Navigate } from 'react-router-dom'
import { Routes } from 'common/constants'

import { EntityTransactionView } from './EntityTransactionView'
import { useEntityTransaction } from '../hooks'

export const EntityTransaction: FC = () => {
  const { isLoading, isError, isNavigateToHome, traceDetails, icon, title, details, footnote } =
    useEntityTransaction()

  if (isLoading) return <Loader />

  if (isError)
    return <ErrorHandler traceDetails={traceDetails} componentName={EntityTransaction.name} />

  if (isNavigateToHome) return <Navigate to={Routes.HOME} replace />

  return <EntityTransactionView icon={icon} title={title} details={details} footnote={footnote} />
}
